// extracted by mini-css-extract-plugin
export default {"stateSelector":"onfido-sdk-ui-Capture-StateSelector-stateSelector"};